var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.627 12.9971V9.57227L23.8701 9.5791C22.9038 9.58276 21.9487 9.60913 21.7476 9.63745C21.4805 9.67505 21.0845 9.78394 20.7329 9.90723C20.4902 9.99243 20.269 10.0845 20.126 10.165C19.5977 10.4629 19.1558 10.8494 18.8076 11.3162C18.5728 11.6311 18.3809 11.9827 18.2339 12.3679C17.9395 13.1392 17.9141 13.3557 17.8848 15.3547L17.8569 17.2266H14.6074V20.8875H17.8682V30.4277H21.7471L21.7759 20.9153L25.4585 20.886V17.2266H21.7383L21.7759 14.1401L21.9453 13.8132C22.1294 13.4587 22.4409 13.218 22.8525 13.1133C22.9307 13.0935 23.2451 13.0703 23.6504 13.0518C23.8647 13.042 24.1045 13.0334 24.3481 13.0276L25.627 12.9971Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.116699 20C0.116699 8.95435 9.07129 0 20.1167 0C31.1572 0.0124512 40.1045 8.95972 40.1167 20C40.1167 31.0457 31.1621 40 20.1167 40C9.07129 40 0.116699 31.0457 0.116699 20ZM1.4502 20C1.4502 30.3093 9.80762 38.6667 20.1167 38.6667C30.4209 38.655 38.7715 30.3044 38.7832 20C38.7832 9.69067 30.4258 1.33325 20.1167 1.33325C9.80762 1.33325 1.4502 9.69067 1.4502 20Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.690389f3.svg";
export { ForwardRef as ReactComponent };